<div class="c-onboardingQuestEnd">
  <div class="c-onboardingQuestEnd__container">
    <div
      class="c-onboardingQuestEnd__background"
      theming
      themingGroup="onboardingquest"
      themingAsset="challenge-completed-background"
      [themingOverride]="onboardingQuestEndModalData?.data?.properties?.assets">
      <span class="title">{{ 'home.live-ops.onboarding-quest.congrats' | translate }}</span>

      <span class="subtitle">{{ 'home.live-ops.onboarding-quest.all-completed' | translate }}</span>

      <span class="subtitle">{{ 'home.live-ops.onboarding-quest.discover' | translate }}</span>

      <slotcom-button
        class="c-button--pink"
        audioType="functionality"
        (safeClick)="closeModal()">
        {{ buttonText | uppercase }}
      </slotcom-button>
    </div>
  </div>
</div>
